import { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/react';

import Box from '@mui/material/Box';

import { SomethingWentWrongView } from 'src/views/error';

type ErrorBoundaryProps = {
  children: ReactNode;
  fallback?: ReactNode | ((handleReset: () => void) => ReactNode);
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);

    Sentry.captureException(error, { extra: { componentStack: errorInfo.componentStack } });
  }

  componentDidUpdate() {
    console.log('this.state.hasError', this.state.hasError);
  }

  private readonly handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return typeof this.props.fallback === 'function'
          ? this.props.fallback(this.handleRetry)
          : this.props.fallback;
      }
      return (
        <Box sx={{ py: 8 }}>
          <SomethingWentWrongView onRetry={this.handleRetry} />
        </Box>
      );
    }
    return this.props.children;
  }
}
